var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"line"}},[_c('div',{ref:"echarts",staticClass:"chart-box"})])}
var staticRenderFns = []

export { render, staticRenderFns }